module.exports = __webpack_public_path__ + "img/gasnatural.24351c04.svg";